import { back, hamburger } from "@/assets/images/index";
import { useDesignMaxTheme } from "@/packages";
import { Center, chakra, Flex, Image, Img } from "@chakra-ui/react";
import styled from "@emotion/styled";
import { useBookingRecoilValue, useNewNavigate, useToggleValue } from "@shared/client";
import { DetailMenuBar, ToggleMenu } from "./components";
import { type HeaderProps } from "./types";

export const Header = ({ logoUrl, navigation }: HeaderProps) => {
    const isMenu = useToggleValue();
    const { isMobile, isLaptop } = useDesignMaxTheme().MEDIAS();
    const { onNavigate } = useNewNavigate();
    const bookingURL = useBookingRecoilValue();
    return (
        <S.Wrapper
            h={isLaptop ? "60px" : "88px"}
            sx={{
                _hover: {
                    "& .hamburger_menu": {
                        background: !isMenu
                            ? `url(${hamburger})no-repeat center/cover`
                            : `url(${back})no-repeat center/cover`,
                    },
                },
            }}
        >
            <Center
                maxW="1600px"
                w="100%"
                p="0 24px"
                justifyContent="space-between"
                columnGap={isMobile ? "24px" : "48px"}
                flexDir={isMobile ? "row-reverse" : "row"}
            >
                <Flex flex="1" justifyContent="space-between">
                    <Img
                        src={logoUrl}
                        w={isMobile ? "98px" : "184px"}
                        h={isMobile ? "32px" : "60px"}
                        cursor="pointer"
                        onClick={() => {
                            onNavigate({ path: "/home" });
                            window.scrollTo({ top: 0, behavior: "smooth" });
                        }}
                    />
                    <Flex gap="24px">
                        <Image
                            w={isMobile ? "40px" : "48px"}
                            h={isMobile ? "40px" : "48px"}
                            cursor="pointer"
                            src={`${process.env.PUBLIC_URL}/assets/icons/clockCalendar.png`}
                            onClick={() => window.open(bookingURL, "_blank")}
                        />
                        <ToggleMenu>
                            <DetailMenuBar navigation={navigation} />
                        </ToggleMenu>
                    </Flex>
                    {/* <GlobalNavBar navigation={navigation} /> */}
                </Flex>
            </Center>
        </S.Wrapper>
    );
};

const Wrapper = styled(chakra.header)`
    width: 100%;
    position: fixed;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9995;
    transition: 1s cubic-bezier(0.175, 0.885, 0.32, 1.275);

    &:hover {
        background: rgba(0, 0, 0, 0.4);
        & svg {
            color: white !important;
        }
        & > div > div:nth-of-type(2) {
            color: white !important;
        }
    }
`;

const S = { Wrapper };
